import { render, staticRenderFns } from "./WebViewer.vue?vue&type=template&id=5c994e6b&scoped=true"
import script from "./WebViewer.vue?vue&type=script&lang=js"
export * from "./WebViewer.vue?vue&type=script&lang=js"
import style0 from "./WebViewer.vue?vue&type=style&index=0&id=5c994e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c994e6b",
  null
  
)

export default component.exports